(() => {
  "use strict";

  var e = {
      3606: (e, t, r) => {
        r.d(t, {
          default: () => p
        });
        var n,
          o = r(6958),
          i = r.n(o),
          a = r(4702),
          c = r.n(a),
          u = r(7518),
          s = r.n(u),
          l = r(5834),
          d = r(3160);
        const p = s().div.withConfig({
          shouldForwardProp: function (e, t) {
            return ![].concat(i()(d.h), ["order"]).includes(e) && t(e);
          }
        }).attrs(function (e) {
          var t = e.dataTestId;
          return t && {
            "data-testid": t
          };
        })(n || (n = c()(["\n  cursor: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (e) {
          return e.onClick ? "pointer" : void 0;
        }, l.border, l.boxShadow, l.color, l.flexbox, l.layout, l.position, l.space, d.S);
      },
      272: (e, t, r) => {
        r.d(t, {
          default: () => h
        });
        var n,
          o,
          i = r(6689),
          a = r.n(i),
          c = r(4702),
          u = r.n(c),
          s = r(7518),
          l = r.n(s),
          d = l().div(n || (n = u()(["\n  padding: 4px;\n  cursor: pointer;\n"]))),
          p = l().div(o || (o = u()(["\n  height: 8px;\n  border-radius: 4px;\n  width: ", ";\n  opacity: ", ";\n  background-color: ", ";\n  transition: 500ms;\n"])), function (e) {
            var t = e.isActive;
            return "".concat(t ? 24 : 8, "px");
          }, function (e) {
            return e.isActive ? 1 : .3;
          }, function (e) {
            var t,
              r = e.theme;
            return (null == r || null === (t = r.colors) || void 0 === t ? void 0 : t.primary) || "black";
          });
        const f = function (e) {
          var t = e.dataTestId,
            r = e.isActive,
            n = e.onClick;
          return a().createElement(d, {
            "data-testid": t,
            onClick: n
          }, a().createElement(p, {
            isActive: r
          }));
        };
        var v;
        const m = l().div(v || (v = u()(["\n  display: flex;\n"]))),
          h = function (e) {
            for (var t = e.dataTestId, r = e.items, n = e.activeItem, o = e.itemComponent, i = void 0 === o ? f : o, c = e.handleClick, u = void 0 === c ? function () {
                return null;
              } : c, s = [], l = function (e) {
                s.push(a().createElement(i, {
                  dataTestId: t && "".concat(t, "-item-").concat(e),
                  key: e,
                  isActive: e === n,
                  onClick: function () {
                    return u(e);
                  }
                }));
              }, d = 0; d < r; d++) l(d);
            return s.length > 1 ? a().createElement(m, {
              "data-testid": t
            }, s.map(function (e) {
              return e;
            })) : null;
          };
      },
      3160: (e, t, r) => {
        r.d(t, {
          S: () => n,
          h: () => o
        });
        var n = (0, r(5834).system)({
            gap: {
              property: "gap",
              scale: "space"
            },
            rowGap: {
              property: "rowGap",
              scale: "space"
            },
            columnGap: {
              property: "columnGap",
              scale: "space"
            }
          }),
          o = ["display", "width", "height", "overflow", "size", "color", "opacity"];
      },
      8779: e => {
        e.exports = require("@babel/runtime/helpers/defineProperty");
      },
      8213: e => {
        e.exports = require("@babel/runtime/helpers/extends");
      },
      353: e => {
        e.exports = require("@babel/runtime/helpers/slicedToArray");
      },
      4702: e => {
        e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
      },
      6958: e => {
        e.exports = require("@babel/runtime/helpers/toConsumableArray");
      },
      6689: e => {
        e.exports = require("react");
      },
      7518: e => {
        e.exports = require("styled-components");
      },
      5834: e => {
        e.exports = require("styled-system");
      }
    },
    t = {};
  function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var i = t[n] = {
      exports: {}
    };
    return e[n](i, i.exports, r), i.exports;
  }
  r.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return r.d(t, {
      a: t
    }), t;
  }, r.d = (e, t) => {
    for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (() => {
    r.r(n), r.d(n, {
      default: () => b
    });
    var e,
      t = r(8213),
      o = r.n(t),
      i = r(8779),
      a = r.n(i),
      c = r(353),
      u = r.n(c),
      s = r(6689),
      l = r.n(s),
      d = r(272),
      p = r(3606),
      f = r(4702),
      v = r.n(f),
      m = r(7518);
    const h = r.n(m)().div.attrs(function (e) {
      var t = e.containerOffset;
      return {
        style: {
          transform: "translate(".concat(t, "%)")
        }
      };
    })(e || (e = v()(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  transition-duration: ", ";\n"])), function (e) {
      var t = e.duration;
      return "".concat(t, "ms");
    });
    function y(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    const b = function (e) {
      var t = e.dataTestId,
        r = e.items,
        n = void 0 === r ? [] : r,
        i = e.itemsPerPage,
        c = void 0 === i ? 1 : i,
        f = e.itemComponent,
        v = e.transitionDuration,
        m = void 0 === v ? 500 : v,
        b = e.indicatorComponent,
        g = void 0 === b ? d.default : b,
        x = e.onSlideBefore,
        O = e.onSlideAfter,
        P = e.onStepChange,
        w = e.startPage,
        j = void 0 === w ? 0 : w,
        S = e.direction,
        T = void 0 === S ? "ltr" : S,
        k = (0, s.useRef)(0),
        C = (0, s.useState)(j),
        E = u()(C, 2),
        A = E[0],
        M = E[1],
        I = function (e, t, r) {
          var n = 100 / t,
            o = n * r * Math.floor(t),
            i = Math.ceil(e / Math.floor(t)),
            a = i - 1 === r,
            c = e - r * Math.floor(t);
          return {
            offset: a && (t % 2 > 0 || e % 2 > 0) ? o - 100 + n * c : o,
            itemWidth: n,
            indicatorsAmount: i
          };
        }(n.length, c, A),
        q = I.offset,
        _ = I.itemWidth,
        D = I.indicatorsAmount,
        G = "ltr" === T,
        W = G ? -q : q,
        X = function (e) {
          A !== e && (P && P({
            previousPage: A,
            currentPage: e
          }), M(e));
        },
        z = n.map(function (e, t) {
          return function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? y(Object(r), !0).forEach(function (t) {
                a()(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }
            return e;
          }({
            key: "slider-item-".concat(t)
          }, e);
        });
      return l().createElement(p.default, {
        dataTestId: t,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflowX: "hidden"
      }, l().createElement(h, {
        "data-testid": t && "".concat(t, "-container"),
        onTouchStart: function (e) {
          var t = e.touches[0];
          k.current = t.clientX;
        },
        onTouchEnd: function (e) {
          var t = e.changedTouches[0].clientX - k.current;
          if (Math.abs(t) >= 50) if (G ? t < 0 : t > 0) {
            var r = A < D - 1 ? A + 1 : A;
            r === A ? O && O({
              currentPage: A
            }) : X(r);
          } else {
            var n = A > 0 ? A - 1 : A;
            n === A ? x && x({
              currentPage: A
            }) : X(n);
          }
        },
        containerOffset: W,
        duration: m
      }, z.map(function (e, t) {
        return l().createElement(p.default, {
          key: e.key,
          minWidth: "".concat(_, "%")
        }, l().createElement(f, o()({
          index: t
        }, e)));
      })), l().createElement(p.default, {
        display: "flex",
        justifyContent: "center"
      }, l().createElement(g, {
        dataTestId: t && "".concat(t, "-indicator"),
        items: D,
        activeItem: A,
        handleClick: function (e) {
          return X(e);
        }
      })));
    };
  })();
  var o = exports;
  for (var i in n) o[i] = n[i];
  n.__esModule && Object.defineProperty(o, "__esModule", {
    value: !0
  });
})();